export default "__VITE_ASSET__DiGsTJ5w__"